import { isDesktop } from 'react-device-detect';
import styles from './Loading.module.scss';
import slide from '../../assets/slide.png';
import close from '../../assets/close.png';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useMobileSlide from '../../hook/MobileSlide';
import loading from '../../assets/loading.png';
import { useEffect, useState } from 'react';

interface IPropsType {
  closer: React.Dispatch<React.SetStateAction<boolean>>;
}

// function Loading(props: IPropsType) {
function Loading({ onLoadFinish }: any) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  // const { modalRef, handleTouchStart, handleTouchMove, handleTouchEnd } =
  //   useMobileSlide({ closer: props.closer });

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          onLoadFinish();
          return 100;
        }
        return prev + 1;
      });
    }, 30);

    return () => clearInterval(interval);
  }, []);

  const [progress, setProgress] = useState(0);

  return (
    <div className={`${styles.container} ${isDesktop ? styles.isDesktop : ''}`}>
      <div
        className={styles.contentWrap}
        // ref={modalRef}
        // onTouchStart={handleTouchStart}
        // onTouchMove={handleTouchMove}
        // onTouchEnd={handleTouchEnd}
      >
        {isDesktop ? (
          <div className={styles.closeWrap}>
            <img
              src={close}
              alt="close"
              onClick={() => {
                navigate('?');
              }}
            />
          </div>
        ) : (
          <div className={styles.slideWrap}>
            <img src={slide} alt="slide" />
          </div>
        )}
        <div className={styles.mainWrap}>
          <div className={styles.topWrap}>
            <div className={styles.imgWrap}>
              <img src={loading} alt="loading" />
            </div>
            <div className={styles.alertWrap}>
              {t('loading.1')}
              <br />
              {t('loading.2')}{' '}
              <span className={styles.hit}>{t('loading.3')}</span>{' '}
              {t('loading.4')}
            </div>
            <span>{t('loading.5')}</span>
          </div>
          <div className={styles.barWrap}>
            <div className={styles.progressBar}>
              <div
                className={styles.progress}
                style={{ width: `${progress}%` }}
              ></div>
            </div>
            <span>{t('loading.6')}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Loading;
